import { Alert, Container } from '@mui/material'

export default function OnlyWebView() {
   return (
      <Container sx={{ mt: 5, textAlign: 'center' }}>
         <Alert severity="error">
            Halaman Ujian hanya bisa dibuka melalui Aplikasi{' '}
            <strong>MyExamBrowser di Android</strong> atau{' '}
            <strong>SafeExamBrowser untuk iOS</strong>
         </Alert>
      </Container>
   )
}
